/** Wallet ids every app's AppKit connect modal pins to the top (Reown explorer ids), in order. */
export const FEATURED_WALLET_IDS = [
  'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa', // Base (formerly Coinbase Wallet)
  '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4', // Binance
  '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust
  '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662', // Bitget
  '8837dd9413b1d9b585ee937d27a816590248386d9dbf59f5cd3422dbbb65683e' // Robinhood
]
